<div class="dialog-edit-team dialog">

    <h2 mat-dialog-title class="modal-header">
        @if(data.team) {Modifier une équipe} @else {Créer une équipe}
    </h2>

    <mat-dialog-content class="modal-content">
        @if (loadings.loadRaces) {
        <aoe-loading-spinner>
            <span info>Chargement des parcours éligibles aux équipes</span>
        </aoe-loading-spinner>
        } @else {
        <aoe-edit-team-form [team]="data.team" [teamsRaces]="races"></aoe-edit-team-form>
        }

    </mat-dialog-content>

    <div ma-dialog-footer>

    </div>
</div>